import { useState } from "react";
import axios from "axios";

export default function Admin() {
  const [url, setUrl] = useState("");
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchFeed = async () => {
  try {
    const res = await axios.post(
      "https://api.pranaw.net/api/feed/preview",
      { url },
      {
        auth: {
          username: "rootadmin",
          password: "admin@234"
        }
      }
    );

    setArticles(res.data.articles);
  } catch (err) {
    alert("Auth failed or error");
  }
};

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-6xl mx-auto">

        {/* Header */}
        <h1 className="text-3xl font-bold mb-6">📰 Admin RSS Panel</h1>

        {/* Input */}
        <div className="flex gap-2 mb-6">
          <input
            type="text"
            placeholder="Enter RSS URL..."
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            className="flex-1 p-3 border rounded-lg shadow-sm"
          />
          <button
            onClick={fetchFeed}
            className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700"
          >
            {loading ? "Loading..." : "Fetch"}
          </button>
        </div>

        {/* Articles Preview */}
        <h2 className="text-xl font-semibold mb-3">Articles Preview</h2>

        <div className="grid md:grid-cols-2 gap-4 mb-8">
          {articles.map((a, i) => (
            <div key={i} className="bg-white p-4 rounded-xl shadow">
              {a.image && (
                <img
                  src={a.image}
                  alt=""
                  className="w-full h-40 object-cover rounded mb-2"
                />
              )}
              <h3 className="font-bold text-lg mb-2">{a.title}</h3>
              <p className="text-sm text-gray-600 mb-2">
                {new Date(a.pubDate).toLocaleString()}
              </p>
              <p className="text-gray-700 text-sm line-clamp-3">
                {a.content}
              </p>
              <a
                href={a.link}
                target="_blank"
                rel="noreferrer"
                className="text-blue-500 text-sm mt-2 inline-block"
              >
                Read More →
              </a>
            </div>
          ))}
        </div>

        {/* JSON Preview */}
        <h2 className="text-xl font-semibold mb-3">JSON Preview</h2>

        <div className="bg-black text-green-400 p-4 rounded-lg overflow-auto max-h-96 text-sm">
          <pre>{JSON.stringify(articles, null, 2)}</pre>
        </div>

      </div>
    </div>
  );
}